import { gql } from "@apollo/client"

export const getKeeper = gql`
  query adminGetKeeper($id: String!) {
    adminGetKeeper(id: $id) {
      keeper {
        id
        email
        phone
        firstName
        lastName
        createdAt
        lastLogin
        status
        address {
          id
          streetLine
          zipcode
          city
          status
          housingType
          digicode
          building
          floor
          instructions
          maxParcels
        }
        nbTotalDeliveredParcels
        anonymized
        anonymizationDate
      }
      documents {
        id
        type
        url
        status
      }
      availabilities {
        id
        date
        startHour
        endHour
        recurring
      }
      carriers {
        allowed
        carrierId
        carrierName
        externalId
        expiredSince
        disablingRequestedBy
        disablingReason
        internalComment
      }
      keeperScoring {
        rating
        deliveryFailureRate {
          totalRate
          colissimo
          geodis
          gls
          relaisColis
          dhl
          ups
        }
        deliveryTime
        contactTime
        commitment7Days
        commitment30Days
      }
      note {
        id
        content
        zendeskLink
      }
      listAddresses {
        id
        status
      }
      vacation {
        id
        start
        end
        addressId
      }
    }
  }
`

export const getKeeperWallet = gql`
  query adminGetKeeperWallet($id: String!) {
    adminGetKeeperWallet(id: $id) {
      id
      bankAccount {
        isStripeValidated
        updatedAt
      }
      balanceDetails {
        nbParcels
        processing
        amount
        type
        date
        associationName
        entity
        parcels {
          id
          parcelNo
        }
      }
      balance
    }
  }
`

export const getKeeperEvents = gql`
  query adminGetKeeperEvents($id: String!) {
    adminGetKeeperEvents(id: $id) {
      id
      entityId
      entity
      eventCode
      eventDate
      eventReason
      title
      description
      data
    }
  }
`

export const getKeepersToCheck = gql`
  query adminGetKeepersToCheck {
    adminGetKeepersToCheck {
      id
      email
      phone
      firstName
      lastName
      createdAt
      pictureUrl
      status
      address {
        id
        streetLine
        zipcode
        city
        status
        housingType
        digicode
        building
        floor
        instructions
        maxParcels
      }
      documents {
        id
        type
        url
        status
      }
      validationReason
      currentOpenAiValidationLog {
        status
        idcardStatus
        addressStatus
        explanationToUser
        explanationToAgent {
          ageOK
          fullNameID
          documentType
          expirationOK
          addressNumber
          birthdateMatch
          documentNumber
          frontPhotoSide
          photoVisibility
          documentAvailable
          nameSurnameMatch
          addressInstruction
        }
      }
    }
  }
`
